export const COMMENT_MODAL_TEST_ID = 'comment-modal-text-field'
